const smartride = {
  id: 1,
  slug: "smartride",

  title: "SmartRide",

  description:
    "A modern ride-booking platform featuring dedicated passenger and driver applications with a centralized admin dashboard. Built for secure, real-time ride management, GPS tracking, payments, and fleet operations.",

  category: "Transportation",
  type: "Client Project",
  status: "Completed",
  year: "2026",

  timeline: "4 Months",

  developedBy: "Horyzen Technologies",

  role: "Full Stack Mobile Development",

  technologies: [
    "Flutter",
    "Node.js",
    "Express.js",
    "MongoDB",
    "Firebase",
    "Google Maps API",
    "REST API"
  ],

  image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1600&q=80",

  liveUrl: "",
  githubUrl: "",

  featured: true
};

export default smartride;